import(/* webpackMode: "eager", webpackExports: ["AboutPageContent"] */ "/workspace/src/app/about/about-page-content.tsx");
